import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  CensimentoDocumentiFormComponent
} from 'src/app/common/form/censimento-documenti-form/censimento-documenti-form.component';
import { SezioneCensimentoDocumentiResponse } from 'src/app/common/models/dto/sezione-censimento-document-response';
import {
  SezioneCensimentoDocumenti
} from 'src/app/common/models/sezioni/sezione-censimento-documenti/sezione-censimento-documenti';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [censimento-documenti-add]',
  templateUrl: 'censimento-documenti-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class CensimentoDocumentiAddComponent{
  @ViewChild('formCensimentoDocumentiAdd') formCensimentoDocumenti: CensimentoDocumentiFormComponent;

  @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();

  inizializza(urlInsert: string, idFascicolo: string, idSezione: string, sezione: SezioneCensimentoDocumenti, inserimento: boolean) {
    this.formCensimentoDocumenti.inizializza(urlInsert, idFascicolo, idSezione, sezione, inserimento);
    openModal('modalAddCensimentoDocumenti');
  }

  createForm() {
    this.formCensimentoDocumenti.createForm();
  }

  manageModal(response: SezioneCensimentoDocumentiResponse) {
    closeModal('modalAddCensimentoDocumenti');
    this.onReturn.emit(response);
  }
}
